<app-cards-basic title="{{ 'BENCHMARK.list' | translate }}"
                 [loading]="isLoading">
  <form class="benchmark-form">
    <mat-form-field class="w-100">
      <mat-label>{{ 'BENCHMARK.benchmark_search' | translate }}</mat-label>
      <input type="text"
             matInput
             [formControl]="searchControl"
             [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="openDialog($event.option.value)">
        <mat-option *ngFor="let result of searchResults | async" [value]="result">
        <span *ngIf="result.type === 'benchmark'">
          [Benchmark] {{ result.symbol }} - {{ result.name }}
        </span>
          <span *ngIf="result.type === 'product'">
          [Product] {{ result.translations[this.currentLanguage]?.title }}
        </span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </form>


  <mat-chip-set aria-label="Benchmark selection">
    @for (benchmark of benchmarkData; track benchmark) {
      <mat-chip-row (removed)="deleteBenchmark(benchmark)">
        {{ benchmark.name }}
        <button matChipRemove [attr.aria-label]="'remove ' + benchmark.name">
          <mat-icon>
            <span class="material-symbols-outlined">close</span>
          </mat-icon>
        </button>
      </mat-chip-row>
    }
  </mat-chip-set>
</app-cards-basic>

@if (benchmarkData && pageList.length) {
  <app-cards-basic title="{{ 'BENCHMARK.activate_on_page' | translate }}">
    @for (benchmark of benchmarkData; track benchmark) {
      <h3 class="pt-4">{{ benchmark.name }}</h3>
      <mat-nav-list>
        @for (page of pageList; track page) {
          <div mat-list-item>
            <mat-checkbox
              [checked]="isBenchmarkAssignedToPage(page, benchmark)"
              (change)="toggleBenchmarkAssignment(page, benchmark, $event.checked)">
            </mat-checkbox>
            <span matListItemTitle>{{ page.translations[currentLanguage].title }}</span>
          </div>
        }
      </mat-nav-list>
    }
  </app-cards-basic>
}


@if (benchmarkData) {
  <app-cards-basic title="Aktiviere Benchmark für Berechnungen">
    <mat-radio-group
      aria-labelledby="example-radio-group-label"
      class="example-radio-group"
      [value]="selectedBenchmark"
      (change)="onBenchmarkChange($event.value)">
      @for (benchmark of benchmarkData; track benchmark) {
        <mat-radio-button class="example-radio-button"
                          [value]="benchmark">
          {{benchmark.name}}
        </mat-radio-button>
        <br>
      }
    </mat-radio-group>
  </app-cards-basic>
}



